var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0, 0, 0)",
    d: "M1.075,14.011 L14.510,0.575 C14.901,0.185 15.534,0.185 15.925,0.575 C16.315,0.966 16.315,1.599 15.925,1.990 L2.490,15.425 C2.099,15.815 1.466,15.815 1.075,15.425 C0.685,15.034 0.685,14.401 1.075,14.011 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0, 0, 0)",
    d: "M15.925,14.011 L2.490,0.575 C2.099,0.185 1.466,0.185 1.075,0.575 C0.685,0.966 0.685,1.599 1.075,1.990 L14.510,15.425 C14.901,15.815 15.534,15.815 15.925,15.425 C16.315,15.034 16.315,14.401 15.925,14.011 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8728c7bf0a66fe8ca7c3e3d695f57d43.svg";
export { ForwardRef as ReactComponent };